import React from 'react';
import {Navigate, useLocation} from 'react-router'
import {useSelector} from 'react-redux';
import { useLingui } from '@lingui/react/macro';

function GuestRoute({component: Component, ...rest}) {
    const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);
    const {t} = useLingui();

    const location = useLocation();

    if (isAuthenticated) {
        return <Navigate to={t({id: "/dashboard"})} replace />;
    }

    return <Component {...rest} location={location} />;
}

export default GuestRoute;